import { CommandCode } from "../../utils/network/generated/protoTypes";
export var checkForFbConnectError = function (path) { return function (action) {
    if (action.id === CommandCode.FacebookConnectInfo ||
        action.id === CommandCode.FacebookConnect) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/checkForFbConnectError.ts
// module id = 1847
// module chunks = 3